import React, { useState } from 'react';
import './style.css';
import {
  Button,
  DatePicker,
  message,
  Space,
  Table,
  Tag,
  Typography,
} from 'antd';
import type { DatePickerProps } from 'antd';
import Container from '~/App/components/Container';
import Header from '~/App/components/Header';
import StickyHeader from '~/App/components/StickyHeader';
import { RangePickerProps } from 'antd/lib/date-picker';
import moment from 'moment';
import { CashierBalancing } from '~/types/CashierBalancing';
import { getCashierBalancings } from '../../api';
import { usePrintReport } from '~/App/hooks';

const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return current > moment().endOf('day');
};

const CloseCashierHistory = () => {
  const [date, setDate] = useState<moment.Moment | null>(moment());
  const handleChangeDatePicker: DatePickerProps['onChange'] = (
    date,
    dateString
  ) => {
    setDate(date);
  };

  const [cashierBalancings, setCashierBalancings] = useState<
    CashierBalancing[]
  >([]);
  const handleClickButtonSearch = async () => {
    if (date === null) {
      message.error('Pilih tanggal terlebih dahulu!');
      return;
    }
    const { data } = await getCashierBalancings(date.format('YYYY-MM-DD'));
    setCashierBalancings(data);
  };

  const { printCashierReport, printCashierSoldItems } = usePrintReport();
  const handleClickPrint = async (cashierBalancingId: string) => {
    // Print cashier report.
    await printCashierReport(cashierBalancingId);
    // Print cashier sold items.
    await printCashierSoldItems(cashierBalancingId);
  };
  const columns = [
    {
      title: 'Cashier',
      dataIndex: 'username',
      key: 'cashier',
    },
    {
      title: 'Open Time',
      dataIndex: 'openTime',
      key: 'openTime',
    },
    {
      title: 'End TIme',
      dataIndex: 'endTime',
      key: 'endTime',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, { status }: { status: string }) => (
        <Tag color={status == 'CLOSED' ? 'success' : 'warning'}>{status}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: CashierBalancing) => (
        <Button
          disabled={record.status == 'OPEN'}
          onClick={() => handleClickPrint(record.id)}
          type="link"
        >
          Print reports
        </Button>
      ),
    },
  ];

  return (
    <Container>
      <StickyHeader>
        <Header title="History Tutup Kasir" />
      </StickyHeader>
      <div style={{ padding: 16 }}>
        <DatePicker
          disabledDate={disabledDate}
          onChange={handleChangeDatePicker}
          value={date}
        />
        <Button
          onClick={handleClickButtonSearch}
          type="primary"
          style={{ marginLeft: 5 }}
        >
          Search
        </Button>
        <br />
        <br />
        <Table
          dataSource={cashierBalancings}
          columns={columns}
          pagination={false}
          scroll={{ x: true }}
        />
      </div>
    </Container>
  );
};

export default CloseCashierHistory;
